export default {
  actions: {
    cancel: "Cancelar",
    withdraw: "Retirar",
    delete: "Eliminar",
    askConfirm: "¿Quiere confirmar?",
    confirm: "Confirmar",
    downloadData: "Descargar datos",
    changePlan: "Cambiar plan",
    send: "Enviar",
    enter: "Entrar",
    back: "Volver",
    next: "Siguiente",
    skip: "Saltar este paso",
    create: "Crear",
    save: "Guardar",
    deleteAccount: "Eliminar cuenta",
    search: "Buscar",
    yes: "Sí",
    no: "No",
    active: "Activar",
    close: "Cerrar",
    goToLogin: "Ir al login",
    alreadyConnected: "Conectado",
    connectToStripe: "Conectar Stripe"
  },
  notifications: {
    changeSuccess: "Cambios guardados con éxito",
    upgradeToPremium:
      "Debe tener una suscripción premium para usar esta función"
  },
  error: {
    generic: "Ops! Ha ocurrido un error, por favor inténtalo de nuevo.",
    subscription: {
      plans: "Ha ocurrido un error obteniendo los planes."
    }
  },
  design: {
    button: "Diseño",
    layout: {
      title: "Disposición",
      heading: "Título principal",
      subtitle: "Subtítulo",
      options: {
        left: "Alineado a la izquierda",
        right: "Alineado a la derecha",
        center: "Centrado al completo",
        "left-fill": "Alineado a la izquierda al completo",
        "right-fill": "Alineado a la derecha al completo"
      }
    }
  },
  logout: "Cerrar Sesión",
  nav: {
    Web: "Web",
    Portfolio: "Portfolio",
    Tienda: "Tienda",
    Eventos: "Eventos",
    Cuentas: "Cuentas",
    Socios: "Socios",
    Empresa: "Empresa",
    Asesor: "Asesor",
    NFTs: "NFTs",
    Datos: "Datos",
    Mejora: "Mejora",
    Servicios: "Servicios",
    Blog: "Blog",
    Formación: "Formación"
  },
  helper: {
    maxChars: "(Máx {max} carácteres)",
    image: "{w}x{h}. Max {size}"
  }
};
